import React from 'react';

import { OpenClosedStatusComponentProps } from './OpenClosedStatusComponent.types';
import { OpenClosedStatusComponentView } from './OpenClosedStatusComponent.view';

export const OpenClosedStatusComponent: React.FC<OpenClosedStatusComponentProps> =
  ({ isClosed }: OpenClosedStatusComponentProps) => {
    return <OpenClosedStatusComponentView isClosed={isClosed} />;
  };
